import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { RaceSessionService } from '../timing-tower/race-session.service';
import { FeatureSettingsService } from './feature-settings.service';

export const raceActiveGuard: CanActivateFn = (route) => {
	const raceSessionService = inject(RaceSessionService);
	const router = inject(Router);

	if (raceSessionService.raceTeamsPosition().length === 0) {
		return router.createUrlTree(['/pre-race'], {
			queryParams: route.queryParams,
		});
	}

	return true;
};
export const streamEnabledGuard: CanActivateFn = (route, state) => {
	const featureSettingsService = inject(FeatureSettingsService);
	const router = inject(Router);
	
	if (featureSettingsService.getCurrentFeatureSettings()?.race?.disableStream) {
		return router.createUrlTree(['/pre-race'], {
			queryParams: {
				...route.queryParams,
				preRaceMessage: 'Race Activity Disabled by Admin.',
			},
		});
	}

	return true;
};
